<template>
  <div>
    <library-header/>
    <section class="selected-entry-wrap" :class="{'has-side-bar': displaySidebar }">
      <aside v-if="displaySidebar" class="content-approval-sidebar">
        <library-sidebar/>
      </aside>
      <button class="back" @click="goBack">
        <div class="back-button-wrap">
          <img src="@/assets/images/return_icon.svg" alt="">
        </div>
        <span class="text">{{ $t('RETURN') }}</span>
      </button>
      <section class="selected-entry" v-if="selectedEntry">
        <entry-management-toolbar v-if="hasManagePermission"
                           :collection-entry="selectedEntry"
                           :displayButtonText="true"/>
        <div class="library-content worksheet">
          <entry-info-container/>
          <div class="image-wrap" :class="{ 'audio-wrap': getUploadType === 'audio' }">
            <div class="selected-entry-image-wrap" :class="{ 'audio': getUploadType === 'audio' }">
              <iframe v-if="getUploadType === 'youtube' || getUploadType ==='video'"
                      width="500"
                      height="360"
                      :src="selectedEntry.object.url"
                      allowfullscreen
                      frameborder="0">
              </iframe>
              <div v-else-if="getUploadType === 'audio'" class="audio-container">
                <span class="audio-title">{{ selectedEntry.data.title }}</span>
                <audio controls class="audio">
                  <source :src="selectedEntry.object.url" type="audio/mp3">
                </audio>
              </div>
              <img v-else :src="selectedEntry.data.image" alt="" class="selected-entry-image"/>
            </div>
            <social-media-entry v-if="selectedEntry.data.metadata && selectedEntry.data.metadata.isEnableSocialMedia">
            </social-media-entry>
            <classification-entry
              :classifications="selectedEntry.data.classifications"
            >
            </classification-entry>
          </div>
          <library-footer/>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import ClassificationEntry from '@/components/classification-entry.vue'
import EntryInfoContainer from '@/components/entry-info-container'
import LibraryFooter from '@/components/library-footer.vue'
import { mapState } from 'vuex'
import LibraryHeader from '@/components/library-header.vue'
import SocialMediaEntry from '@/components/social-media-entry.vue'
import { getUploadType } from '@/utilityFunctions'
import { entryApprovalStatuses, permissionTypes, sideBarData } from '@/constants'
import EntryManagementToolbar from '@/components/entry-management-toolbar'
import librarySidebar from '@/components/sidebar'

export default {
  name: 'collection-entry',
  components: {
    EntryManagementToolbar,
    LibraryHeader,
    LibraryFooter,
    ClassificationEntry,
    EntryInfoContainer,
    SocialMediaEntry,
    librarySidebar
  },
  data () {
    return {
      entryApprovalStatuses
    }
  },
  computed: {
    ...mapState({
      selectedEntry: state => state.collections.selectedEntry,
      librarySlug: state => state.base.library?.slug,
      userRoles: state => state.base.userRoles,
      isLibraryUpdated: state => state.base.libraryDataUploaded,
      user: state => state.base.user
    }),
    hasManagePermission () {
      if (this.userRoles?.length) {
        // If the user has some manage permission in his roles.
        const managerRoles = [permissionTypes.ADMIN, permissionTypes.APPROVER, permissionTypes.EDITOR]
        if (managerRoles.some(role => this.userRoles.includes(role))) {
          return true
        } else {
          // If the user has only creator/contributor role,
          // he can edit only his collection-entries
          if (this.selectedEntry.data.metadata?.author_uuid === this.user.uuid) {
            // If the user is contributor - he can edit only his non-published content.
            if (this.userRoles?.includes(permissionTypes.CONTRIBUTOR)) {
              return this.selectedEntry.data.published_status !== entryApprovalStatuses.PUBLISHED
            }
            return true
          }
        }
      }
      // If the user hasn't permissions
      return false
    },
    getUploadType () {
      return getUploadType(this.selectedEntry)
    },
    entryStatus () {
      return this.selectedEntry.data.published_status
    },
    displaySidebar () {
      return this.userRoles?.some(role => sideBarData.visibleTo.includes(role))
    }
  },
  watch: {
    isLibraryUpdated: function () {
      if (this.isLibraryUpdated) {
        const idOfEntry = parseInt(this.$route.params.id)
        this.$store.dispatch('findAndSetEntryById', idOfEntry)
      }
    }
  },
  beforeMount () {
    const idOfEntry = parseInt(this.$route.params.id)
    if (this.isLibraryUpdated) {
      this.$store.dispatch('findAndSetEntryById', idOfEntry)
    }
    if (this.$route.query.searchText) {
      this.$store.dispatch('setSearchWord', this.$route.query.searchText)
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.audio-container {
  display: grid;
  place-content: center;
  gap: 10px;
  height: 180px;
  background-color: #F8F8FD;
}

audio {
  width: 320px;
  height: 70px;
}

audio::-webkit-media-controls-panel {
  background-color: #F8F8FD;
}

.audio-title {
  font-size: 20px;
  margin-inline-start: 14px;
}

@media screen and (max-width: 780px) {
  audio {
    width: 300px;
  }
}

@media screen and (min-width: 781px) {
  audio {
    width: 420px;
  }
}
</style>
